<template>
  <section class="quote-info">
    <template  v-if="isEndorsement">
      <div
        v-for="(item,index) in compareData"
        :key="index"
        class="box">
        <h3 v-if="!item.isBold&&item.title">{{ item.title }}</h3>
        <h2 v-if="item.isBold&&item.title">{{ item.title }}</h2>
        <table
          v-if="!item.isCompare"
          class="table"
          :class="item.class">
          <tr
            v-for="(sumItem,sumIndex) in item.list"
            v-show="sumItem.type!='array' || !sumItem.notShow"
            :key="sumIndex"
            class="tr">
            <td>{{ sumItem.name }}</td>
            <td v-if="formData[sumItem.field] === oldForm[sumItem.field]">
              {{ showCompare(sumItem, formData[sumItem.field]) }}
            </td>
            <td
              v-else
              class="compare">
              <span class="text-line color-danger">
                {{ showCompare(sumItem, oldForm[sumItem.field]) }}
              </span>
              <span class="color-success">
                {{ showCompare(sumItem, formData[sumItem.field]) }}
              </span>
            </td>
          </tr>
        </table>
        <table
          v-else
          class="table"
          :class="item.class">
          <template v-if="formData.cust_typ == 1">
            <tr
              v-for="(sumItem,sumIndex) in item.list"
              v-show="sumItem.type!='array' || !sumItem.notShow"
              :key="sumIndex"
              class="tr">
              <td>{{ sumItem.name }}</td>
              <td v-if="formData[sumItem.field] === oldForm[sumItem.field]">
                {{ showCompare(sumItem, formData[sumItem.field]) }}
              </td>
              <td
                v-else
                class="compare">
                <span class="text-line color-danger">
                  {{ showCompare(sumItem, oldForm[sumItem.field]) }}
                </span>
                <span class="color-success">
                  {{ showCompare(sumItem, formData[sumItem.field]) }}
                </span>
              </td>
            </tr>
          </template>
          <template v-else>
            <div
              v-for="(sumItem,sumIndex) in item.list1"
              v-show="!sumItem.notShow"
              :key="sumIndex">
              <tr
                v-if="!sumItem.isSumbTitle"
                class="tr">
                <td>{{ sumItem.name }}</td>
                <td v-if="formData[sumItem.field] === oldForm[sumItem.field]">
                  {{ showCompare(sumItem, formData[sumItem.field]) }}
                </td>
                <td
                  v-else
                  class="compare">
                  <span class="text-line color-danger">
                    {{ showCompare(sumItem, oldForm[sumItem.field]) }}
                  </span>
                  <span class="color-success">
                    {{ showCompare(sumItem, formData[sumItem.field]) }}
                  </span>
                </td>
              </tr>
              <td
                v-else
                class="title">{{ sumItem.name }}</td>
            </div>
          </template>
        </table>
      </div>
    </template>
    <template v-else>
      <div
        v-for="(item,index) in compareData"
        :key="index"
        class="box" >
        <h2 v-if="item.firstTitle">{{ item.firstTitle }}</h2>
        <h3 v-if="!item.isBold&&item.title">{{ item.title }}</h3>
        <h2 v-if="item.isBold&&item.title">{{ item.title }}</h2>

        <div
          v-if="!item.isCompare"
          class="table"
          :class="item.class">
          <div
            v-for="(sumItem,sumIndex) in item.list"
            v-show="!sumItem.notShow"
            :key="sumIndex"
            class="tr">
            <span>{{ sumItem.name }}</span>
            <span
              v-if="sumItem.type == 'array'"
            >
              <span
                v-for="(sum,index) in sumItem.value"
                :key="'sum'+index"
                v-copy="sum.name">{{sum.name}}<br></span>
            </span>
            <span
              v-else
              v-copy="showCompare(sumItem, formData[sumItem.field])">
              <span v-if="sumItem.type == 'value'">{{ sumItem.value }}</span>
              <span v-else>{{ showCompare(sumItem, formData[sumItem.field]) }}</span>

            </span>
          </div>
        </div>
        <div
          v-else
          class="table"
          :class="item.class">
          <template v-if="formData.cust_typ == 1">
            <div
              v-for="(sumItem,sumIndex) in item.list"
              :key="sumIndex"
              class="tr">
              <span>{{ sumItem.name }}</span>
              <span
                v-if="sumItem.type == 'array'"
              >
                <span
                  v-for="(sum,index) in sumItem.value"
                  :key="'sum'+index"
                  v-copy="sum.name">{{sum.name}}<br></span>
              </span>
              <span
                v-else
                v-copy="showCompare(sumItem, formData[sumItem.field])">
                {{ showCompare(sumItem, formData[sumItem.field]) }}
              </span>
            </div>
          </template>
          <template v-else>
            <div
              v-for="(sumItem,sumIndex) in item.list1"
              :key="sumIndex">
              <div
                v-if="!sumItem.isSumbTitle"
                class="tr">
                <span>{{ sumItem.name }}</span>
                <span
                  v-if="sumItem.type == 'array'"
                >
                  <span
                    v-for="(sum,index) in sumItem.value"
                    :key="'sum'+index"
                    v-copy="sum.name">{{sum.name}}<br></span>
                </span>
                <span
                  v-else
                  v-copy="showCompare(sumItem, formData[sumItem.field])">
                  {{ showCompare(sumItem, formData[sumItem.field]) }}
                  <email-tooltip
                    v-if="sumItem.field == 'email'"
                    :email="formData.email"></email-tooltip>
                </span>
              </div>
              <span
                v-else
                v-copy="sumItem.name"
                class="title">{{ sumItem.name }}</span>
            </div>
          </template>
        </div>
      </div>
    </template>

  </section>
</template>
<script>
import MixinOptions from '@/mixins/options'
import OMath from '@/utils/math'

export default {
  name: 'DecorationQuoteInfo',
  mixins: [MixinOptions],
  props: {
    formData: {
      type: Object,
      default: () => ({})
    },
    title: {
      type: Boolean,
      default: true
    },
    oldForm: {
      type: Object,
      default: () => ({})
    },
    isEndorsement:{
      type: Boolean,
      default: false
    },
    showCompany:{
      type: Boolean,
      default: false
    },
    isQuote: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      // compareData: [
      //   {
      //     title: '',
      //     class:'mg-b-10',
      //     list:
      //       [
      //         {
      //           name: 'Expected Effective Date ',
      //           field: 'pcy_cmnt_date',
      //         },
      //         {
      //           name: 'Expected Expiry Date',
      //           field: 'pcy_expry_date',
      //         },
      //         {
      //           name: 'Contract Period',
      //           field: 'contr_prd',
      //           fieldCode: 'period',
      //           option: 24
      //         },
      //         {
      //           name: 'Building Age',
      //           field: 'bldg_age',
      //           fieldCode: 'bldg_ages',
      //           option: 24
      //         },
      //         {
      //           name: 'Total Contract Sum',
      //           field: 'tol_contr_sum',
      //         },
      //         {
      //           name: 'Material Damage Coverage',
      //           field: 'mat_dam_cvr_ind',
      //           fieldCode: 'yesNoOptions',
      //           option: 1
      //         },
      //         {
      //           name: 'Third Party Liability Coverage',
      //           field: 'tp_lia_cvr_ind',
      //           fieldCode: 'yesNoOptions',
      //           option: 1
      //         },
      //         {
      //           name: 'Third Party Liability Limit',
      //           field: 'tppd_limit_amt',
      //           fieldCode: 'limit_of_liability',
      //           option: 24
      //         },
      //         {
      //           name: 'Outdoor Work ',
      //           field: 'outdoor_wk_ind',
      //           fieldCode: 'yesNoOptions',
      //           option: 1
      //         },
      //         {
      //           name: 'Total Contract Value of Outdoor Work and/or Scaffolding Work',
      //           field: 'scaffolding_wk',
      //           fieldCode: 'scaffolding_wk',
      //           option: 24
      //         },
      //         {
      //           name: 'Employee Compensation ',
      //           field: 'employee_ind',
      //           fieldCode: 'yesNoOptions',
      //           option: 1
      //         },
      //       ]
      //   },
      //
      //   {
      //     title: 'Policyholder Detail',
      //     isCompare: true,
      //     isBold: true,
      //     list: [
      //       {
      //         name: 'Title',
      //         field: 'isrd_title',
      //         fieldCode: 'titleOptions',
      //         option: 1
      //       }, {
      //         name: 'Last Name',
      //         field: 'isrd_lst_nm'
      //       }, {
      //         name: 'First Name',
      //         field: 'isrd_fst_nm'
      //       }, {
      //         name: this.formData.id_type_language,
      //         field: 'id_no'
      //       }, {
      //         name: 'Mobile Number',
      //         field: 'mobile_no',
      //
      //       }, {
      //         name: 'Email',
      //         field: 'email',
      //
      //       }, {
      //         name: 'Occupation',
      //         field: 'occ',
      //         fieldCode: 'occupation',
      //         option: 24,
      //       },
      //     ],
      //     list1: [
      //       {
      //         name: 'Company Name',
      //         field: 'isrd_com_nm'
      //       }, {
      //         name: 'BR Number',
      //         field: 'id_no'
      //       },
      //       // {
      //       //   name: 'CI Number',
      //       //   field: 'ci_no'
      //       // },
      //       {
      //         name: 'Company Phone No.',
      //         field: 'phone_no'
      //       }, {
      //         name: 'Company Email',
      //         field: 'email'
      //       }, {
      //         name: 'Nature of Business',
      //         field: 'bsns_nature_id',
      //         fieldCode: 'industry',
      //         option: 24
      //       },
      //       // {
      //       //   name: 'Contact Person',
      //       //   isSumbTitle: true
      //       // },
      //       // {
      //       //   name: 'Name',
      //       //   field: 'contact_nm',
      //       //
      //       // }, {
      //       //   name: 'Occupation',
      //       //   field: 'contact_occ_id',
      //       //   fieldCode: 'occupation',
      //       //   option: 24,
      //       // },
      //       // {
      //       //   name: 'Phone No.',
      //       //   field: 'contact_phone',
      //       // },
      //       // {
      //       //   name: 'Email',
      //       //   field: 'contact_email',
      //       //
      //       // },
      //     ]
      //   },
      //   {
      //     title: 'Correspondence Address',
      //     isBold: false,
      //     list: [
      //       {
      //         name: 'Room',
      //         field: 'addr_room'
      //       }, {
      //         name: 'Floor',
      //         field: 'addr_floor'
      //       }, {
      //         name: 'Block',
      //         field: 'addr_block'
      //       }, {
      //         name: 'Building / Estate',
      //         field: 'addr_building'
      //       }, {
      //         name: 'Street',
      //         field: 'addr_street'
      //       }, {
      //         name: 'District',
      //         field: 'addr_district',
      //         addressCode: 'district',
      //         isAddress: true
      //       }, {
      //         name: 'Area',
      //         field: 'addr_area',
      //         isAddress: true,
      //         addressCode: 'area'
      //       }, {
      //         name: 'Country / Region',
      //         field: 'addr_region',
      //         isAddress: true,
      //         addressCode: 'region'
      //       },
      //     ]
      //   },
      //   {
      //     title: 'Location of Works',
      //     firstTitle: 'Work Details',
      //     isBold:false,
      //     list: [
      //       {
      //         name: 'Room',
      //         field: 'work_addr_room',
      //       },
      //       {
      //         name: 'Floor',
      //         field: 'work_addr_floor',
      //       },
      //       {
      //         name: 'Block',
      //         field: 'work_addr_block'
      //       }, {
      //         name: 'Building / Estate',
      //         field: 'work_addr_building'
      //       },
      //       {
      //         name: 'Street',
      //         field: 'work_addr_street',
      //       },
      //       {
      //         name: 'District',
      //         field: 'work_addr_district',
      //         addressCode: 'district',
      //         isAddress:true,
      //       }, {
      //         name: 'Area',
      //         field: 'work_addr_area',
      //         addressCode: 'area',
      //         isAddress:true,
      //       },
      //       {
      //         name: 'Country / Region',
      //         field: 'work_addr_region',
      //         addressCode: 'region',
      //         isAddress:true,
      //       },
      //       {
      //         name: 'Occupied as',
      //         field: 'occupied_as',
      //         fieldCode: 'occupied_as',
      //         option: 24
      //       },
      //     ],
      //   },
      //   // {
      //   //   title:'Contractor',
      //   //   isSpan:true,
      //   //   list:[
      //   //     {
      //   //       name:'Name',
      //   //       field:'con_nm'
      //   //     },     {
      //   //       name:'Phone Number',
      //   //       field:'con_phone_no'
      //   //     }
      //   //   ]
      //   // },
      //   // {
      //   //   title: 'Correspondence Address',
      //   //   isBold: false,
      //   //   isSpan:true,
      //   //   list: [
      //   //     {
      //   //       name: 'Room',
      //   //       field: 'addr_room'
      //   //     },
      //   //     {
      //   //       name: 'Floor',
      //   //       field: 'addr_floor'
      //   //     }, {
      //   //       name: 'Block',
      //   //       field: 'addr_block'
      //   //     }, {
      //   //       name: 'Building / Estate',
      //   //       field: 'addr_building'
      //   //     }, {
      //   //       name: 'Street',
      //   //       field: 'addr_street'
      //   //     }, {
      //   //       name: 'District',
      //   //       field: 'addr_district',
      //   //       addressCode: 'district',
      //   //       isAddress: true
      //   //     }, {
      //   //       name: 'Area',
      //   //       field: 'addr_area',
      //   //       addressCode: 'area',
      //   //       isAddress: true
      //   //     }, {
      //   //       name: 'Country / Region',
      //   //       field: 'addr_region',
      //   //       isAddress: true,
      //   //       addressCode: 'region'
      //   //     },
      //   //   ]
      //   // },
      //   // {
      //   //   title: 'Contractor',
      //   //   isBold: true,
      //   //   list: [
      //   //     {
      //   //       name: 'Name',
      //   //       field: 'con_nm',
      //   //     },
      //   //     {
      //   //       name: 'Phone Number',
      //   //       field: 'con_phone_no',
      //   //     }
      //   //   ]
      //   // },
      //   // {
      //   //   title: 'Correspondence Address',
      //   //   isBold: false,
      //   //   isSpan:true,
      //   //   list: [
      //   //     {
      //   //       name: 'Room',
      //   //       field: 'con_addr_room'
      //   //     },
      //   //     {
      //   //       name: 'Floor',
      //   //       field: 'con_addr_floor'
      //   //     }, {
      //   //       name: 'Block',
      //   //       field: 'con_addr_block'
      //   //     }, {
      //   //       name: 'Building / Estate',
      //   //       field: 'con_addr_building'
      //   //     }, {
      //   //       name: 'Street',
      //   //       field: 'con_addr_street'
      //   //     }, {
      //   //       name: 'District',
      //   //       field: 'con_addr_district',
      //   //       addressCode: 'district',
      //   //       isAddress: true
      //   //     }, {
      //   //       name: 'Area',
      //   //       field: 'con_addr_area',
      //   //       addressCode: 'area',
      //   //       isAddress: true
      //   //     }, {
      //   //       name: 'Country / Region',
      //   //       field: 'con_addr_region',
      //   //       isAddress: true,
      //   //       addressCode: 'region'
      //   //     },
      //   //   ]
      //   // },
      //   {
      //     title: 'Sub Contractors (if any)',
      //     list:
      //       [
      //         {
      //           name: 'Sub Contractors (if any)',
      //           field: 'sub_contractors',
      //
      //         },
      //         {
      //           name: 'Property Management Company (If any)',
      //           field: 'property_management_company',
      //
      //         }
      //       ]
      //   },
      // ]
    }

  },
  computed: {
    compareData(){
      let {quote_coverage_list={},benefits} = this.formData||{}
      let benefitsList = this[`allOptions${this.formData.class_id}`].benefits || []
      let arr =[]
      if(benefitsList.length > 0){
        arr = benefitsList.filter(item => {
          return this.formData.benefits.includes(item.id)
        })
      }
      let list =  [
        {
          title: '',
          class:'mg-b-10',
          list:
            [
              {
                name: 'Expected Effective Date ',
                field: 'pcy_cmnt_date',
                type:'value',
                value:this.formData.is_eff_dt_delay&&this.isQuote?'ASAP':`${this.formData.pcy_cmnt_date} ${this.formData.is_eff_dt_delay&&!this.isQuote?'(ASAP)':''}`
              },
              {
                name: 'Expected Expiry Date',
                field: 'pcy_expry_date',
              },
              {
                name: 'Contract Period',
                field: 'contr_prd',
                fieldCode: 'period',
                option: 24
              },
              {
                name: 'Building Age',
                field: 'bldg_age',
                fieldCode: 'bldg_ages',
                option: 24
              },
              {
                name: 'Total Contract Sum',
                field: 'tol_contr_sum',
              },
              {
                name: 'Material Damage Coverage',
                field: 'mat_dam_cvr_ind',
                fieldCode: 'yesNoOptions',
                option: 1
              },
              {
                name: 'Third Party Liability Coverage',
                field: 'tp_lia_cvr_ind',
                fieldCode: 'yesNoOptions',
                option: 1
              },
              {
                name: 'Third Party Liability Limit',
                field: 'tppd_limit_amt',
                fieldCode: 'limit_of_liability',
                option: 24
              },
              {
                name: 'Outdoor Work ',
                field: 'outdoor_wk_ind',
                fieldCode: 'yesNoOptions',
                option: 1
              },
              {
                name: 'Total Contract Value of Outdoor Work and/or Scaffolding Work',
                field: 'scaffolding_wk',
                fieldCode: 'scaffolding_wk',
                option: 24
              },
              {
                name: 'Employee Compensation ',
                field: 'employee_ind',
                fieldCode: 'yesNoOptions',
                option: 1
              },
              {
                name: 'Optional Benefits',
                field: 'benefits',
                type:'array',
                value:arr
              },
              {
                name: 'Insurer',
                field: 'company_language',
                notShow:!this.showCompany
              },
            ]
        },

        {
          title: 'Policyholder Detail',
          isCompare: true,
          isBold: true,
          list: [
            {
              name: 'Title',
              field: 'isrd_title',
              fieldCode: 'titleOptions',
              option: 1
            }, {
              name: 'Last Name',
              field: 'isrd_lst_nm'
            }, {
              name: 'First Name',
              field: 'isrd_fst_nm'
            }, {
              name: this.formData.id_type_language,
              field: 'id_no'
            },{
              name: 'Nationality',
              field: 'id_nationality_seq_language',
              notShow: this.formData.id_type == 1
            }, {
              name: 'Mobile Number',
              field: 'mobile_no',

            }, {
              name: 'Email',
              field: 'email',

            }, {
              name: 'Occupation',
              field: 'occ',
              // fieldCode: 'occupation',
              // option: 24,
            },
          ],
          list1: [
            {
              name: 'Company Name',
              field: 'isrd_com_nm'
            }, {
              name: 'Business Registration Number',
              field: 'id_no'
            },
            // {
            //   name: 'CI Number',
            //   field: 'ci_no'
            // },
            {
              name: 'Company Phone No.',
              field: 'phone_no'
            }, {
              name: 'Company Email',
              field: 'email'
            }, {
              name: 'Nature of Business',
              field: 'bsns_nature',
              // fieldCode: 'industry',
              // option: 24
            },
            // {
            //   name: 'Contact Person',
            //   isSumbTitle: true
            // },
            {
              name: 'Contact Person Name',
              field: 'contact_nm',

            },
            // {
            //   name: 'Occupation',
            //   field: 'contact_occ_id',
            //   fieldCode: 'occupation',
            //   option: 24,
            // },
            {
              name: 'Contact Person Mobile No.',
              field: 'contact_phone',
            },
            // {
            //   name: 'Email',
            //   field: 'contact_email',
            //
            // },
          ]
        },
        {
          title: 'Correspondence Address',
          isBold: false,
          list: [
            {
              name: 'Room',
              field: 'addr_room'
            }, {
              name: 'Floor',
              field: 'addr_floor'
            }, {
              name: 'Block',
              field: 'addr_block'
            }, {
              name: 'Building / Estate',
              field: 'addr_building'
            }, {
              name: 'Street',
              field: 'addr_street'
            }, {
              name: 'District',
              field: 'addr_district',
              addressCode: 'district',
              isAddress: true
            }, {
              name: 'Area',
              field: 'addr_area',
              isAddress: true,
              addressCode: 'area'
            }, {
              name: 'Country / Region',
              field: 'addr_region',
              isAddress: true,
              addressCode: 'region'
            },
          ]
        },
        {
          title: 'Location of Works',
          firstTitle: 'Work Details',
          isBold:false,
          list: [
            {
              name: 'Room',
              field: 'work_addr_room',
            },
            {
              name: 'Floor',
              field: 'work_addr_floor',
            },
            {
              name: 'Block',
              field: 'work_addr_block'
            }, {
              name: 'Building / Estate',
              field: 'work_addr_building'
            },
            {
              name: 'Street',
              field: 'work_addr_street',
            },
            {
              name: 'District',
              field: 'work_addr_district',
              addressCode: 'district',
              isAddress:true,
            }, {
              name: 'Area',
              field: 'work_addr_area',
              addressCode: 'area',
              isAddress:true,
            },
            {
              name: 'Country / Region',
              field: 'work_addr_region',
              addressCode: 'region',
              isAddress:true,
            },
            {
              name: 'Occupied as',
              field: 'occupied_as',
              fieldCode: 'occupied_as',
              option: 24
            },
          ],
        },
        // {
        //   title:'Contractor',
        //   isSpan:true,
        //   list:[
        //     {
        //       name:'Name',
        //       field:'con_nm'
        //     },     {
        //       name:'Phone Number',
        //       field:'con_phone_no'
        //     }
        //   ]
        // },
        // {
        //   title: 'Correspondence Address',
        //   isBold: false,
        //   isSpan:true,
        //   list: [
        //     {
        //       name: 'Room',
        //       field: 'addr_room'
        //     },
        //     {
        //       name: 'Floor',
        //       field: 'addr_floor'
        //     }, {
        //       name: 'Block',
        //       field: 'addr_block'
        //     }, {
        //       name: 'Building / Estate',
        //       field: 'addr_building'
        //     }, {
        //       name: 'Street',
        //       field: 'addr_street'
        //     }, {
        //       name: 'District',
        //       field: 'addr_district',
        //       addressCode: 'district',
        //       isAddress: true
        //     }, {
        //       name: 'Area',
        //       field: 'addr_area',
        //       addressCode: 'area',
        //       isAddress: true
        //     }, {
        //       name: 'Country / Region',
        //       field: 'addr_region',
        //       isAddress: true,
        //       addressCode: 'region'
        //     },
        //   ]
        // },
        // {
        //   title: 'Contractor',
        //   isBold: true,
        //   list: [
        //     {
        //       name: 'Name',
        //       field: 'con_nm',
        //     },
        //     {
        //       name: 'Phone Number',
        //       field: 'con_phone_no',
        //     }
        //   ]
        // },
        // {
        //   title: 'Correspondence Address',
        //   isBold: false,
        //   isSpan:true,
        //   list: [
        //     {
        //       name: 'Room',
        //       field: 'con_addr_room'
        //     },
        //     {
        //       name: 'Floor',
        //       field: 'con_addr_floor'
        //     }, {
        //       name: 'Block',
        //       field: 'con_addr_block'
        //     }, {
        //       name: 'Building / Estate',
        //       field: 'con_addr_building'
        //     }, {
        //       name: 'Street',
        //       field: 'con_addr_street'
        //     }, {
        //       name: 'District',
        //       field: 'con_addr_district',
        //       addressCode: 'district',
        //       isAddress: true
        //     }, {
        //       name: 'Area',
        //       field: 'con_addr_area',
        //       addressCode: 'area',
        //       isAddress: true
        //     }, {
        //       name: 'Country / Region',
        //       field: 'con_addr_region',
        //       isAddress: true,
        //       addressCode: 'region'
        //     },
        //   ]
        // },
        {
          title: 'Sub Contractors (if any)',
          list:
            [
              {
                name: 'Sub Contractors (if any)',
                field: 'sub_contractors',

              },
              {
                name: 'Property Management Company (If any)',
                field: 'property_management_company',

              }
            ]
        },
      ]
      return list
    }
  },
  methods: {
    showCompare(item, field) {
      let change = field
      if (item.option) {
        switch (item.option) {
          case 1:
            change = this.getOptionName(item.fieldCode, field)
            break
          case 24:
            change = this.getAllOptionName24(item.fieldCode, field)
            break
          case 26:
            change = this.getAllOptionName26(item.fieldCode, field)
            break
        }
      }
      if (item.isAddress) {
        change = this.getAreaName(item.addressCode, field)
      }
      if (item.isSum) {
        change = OMath.formatMoney(field, 2, true) + 'HK$'
      }
      return change
    }
  }
}
</script>
<style lang="scss" scoped>
.quote-info{
  .box {
    margin-bottom: 15px;
  }
  .title {
    padding: 15px 0;
  }
  .table {
    .tr {
      .compare {
        display: flex;
        align-items: center;

        & > span {
          flex: 1;
        }
      }
    }
  }
  .asap{
    font-weight: bold;
    color: black;
    margin-left: 5px;
  }
}
</style>
